"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 */
function UpChevron() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "19", height: "12", viewBox: "0 0 19 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M9.55709 5.0939L15.4886 11.3914C16.2236 12.1717 17.4496 12.2062 18.227 11.4685C19.0044 10.7307 19.0388 9.50003 18.3038 8.7197L10.978 0.941921C10.2187 0.135777 8.94247 0.129683 8.17557 0.928541L0.708908 8.70632C-0.0334423 9.4796 -0.0107321 10.7105 0.759632 11.4557C1.53 12.2009 2.75629 12.1781 3.49864 11.4048L9.55709 5.0939Z", fill: "white" }) }));
}
exports.default = UpChevron;
//# sourceMappingURL=UpChevron.js.map